/* script */
//
//
//
//
//
//
//
//
//
//

// Utils
import { isObject } from 'lodash';

// Components
import MetaControl from 'shared/ui/components/form-components/MetaControl.vue';

const __vue_script__ = {
    name: 'ListFilters',

    components: {
        MetaControl,
    },

    props: {
        value: {
            type: Object,
            required: true
        },

        controller: {
            type: Object,
            required: true
        },

        event: {
            type: Object,
            required: true
        },

        module: {
            type: Object,
            required: true
        },

        metadata: {
            type: Object,
            required: true
        }
    },

    data() {
        const { routeOptions } = this.controller;
        const { crudOpts = {} } = routeOptions || {};
        const filters = crudOpts.filters || [];

        return {
            filters,
            localModel: filters.reduce((acc, filter) => {
                acc[filter.field] = this.value[filter.field] || filter.default;
                return acc;
            }, {})
        };
    },

    watch: {
        localModel: {
            deep: true,
            handler() {
                this.emit();
            }
        }
    },

    created() {
        if (this.filters.length) {
            this.emit();
        }
    },

    methods: {
        emit() {
            this.$emit('input', this.createFilterMap());
        },
        /**
         * Gather all values from currently applied filter and put them into a
         * key-value map {[field: string]: value[]}
         */
        createFilterMap() {
            return this.filters.reduce((acc, filter) => {
                const newFilterValue = this.localModel[filter.field];

                acc[filter.field] = Array.isArray(newFilterValue) ?
                    newFilterValue.map(v => this.extractFilterValue(v)) :
                    [this.extractFilterValue(newFilterValue)];

                return acc;
            }, {});
        },

        /**
         * Extract value from filter input
         * In case of object, extract value from it
         */
        extractFilterValue(filterInput) {
            return isObject(filterInput) ? filterInput.value : filterInput;
        }
    }

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.filters.length)?_c('div',{staticClass:"list-filters"},_vm._l((_vm.filters),function(filter){return _c('meta-control',{attrs:{"settings":{},"control":filter,"event":_vm.event},model:{value:(_vm.localModel[filter.field]),callback:function ($$v) {_vm.$set(_vm.localModel, filter.field, $$v)},expression:"localModel[filter.field]"}})}),1):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ListFilters.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__